import { render, staticRenderFns } from "./OrderBundles.vue?vue&type=template&id=13e79f77"
import script from "./OrderBundles.vue?vue&type=script&lang=js"
export * from "./OrderBundles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports